export default __webpack_public_path__ + "static/media/Category.a9581b94.svg";